import LocalizationConstants from "src/app/constants/localization-constants";
import { UnitOfMeasure } from "src/app/models/Enums";

export interface ParcelDimensionsOption {
  length: number;
  width: number;
  height: number;
}

export type ParcelDimensionsOptionType = "small" | "medium" | "large" | "extraLarge";

export const ParcelOptionsWithLabels: Record<ParcelDimensionsOptionType, string> = {
  small: LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_SMALL,
  medium: LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_MEDIUM,
  large: LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_LARGE,
  extraLarge: LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_EXTRA_LARGE,
};

// Dimensions reference: Chloe Moors from PTD logistics
const ParcelDimensionsCmOptions: Record<ParcelDimensionsOptionType, ParcelDimensionsOption> = {
  small: {
    length: 20,
    width: 20,
    height: 10,
  },
  medium: {
    length: 47,
    width: 36,
    height: 26,
  },
  large: {
    length: 60,
    width: 40,
    height: 30,
  },
  extraLarge: {
    length: 80,
    width: 60,
    height: 40,
  },
};

const CmToInchModifier = 2.54;

const ParcelDimensionsInchOptions: Record<ParcelDimensionsOptionType, ParcelDimensionsOption> = {
  small: {
    length: Math.round(ParcelDimensionsCmOptions.small.length / CmToInchModifier),
    width: Math.round(ParcelDimensionsCmOptions.small.width / CmToInchModifier),
    height: Math.round(ParcelDimensionsCmOptions.small.height / CmToInchModifier),
  },
  medium: {
    length: Math.round(ParcelDimensionsCmOptions.medium.length / CmToInchModifier),
    width: Math.round(ParcelDimensionsCmOptions.medium.width / CmToInchModifier),
    height: Math.round(ParcelDimensionsCmOptions.medium.height / CmToInchModifier),
  },
  large: {
    length: Math.round(ParcelDimensionsCmOptions.large.length / CmToInchModifier),
    width: Math.round(ParcelDimensionsCmOptions.large.width / CmToInchModifier),
    height: Math.round(ParcelDimensionsCmOptions.large.height / CmToInchModifier),
  },
  extraLarge: {
    length: Math.round(ParcelDimensionsCmOptions.extraLarge.length / CmToInchModifier),
    width: Math.round(ParcelDimensionsCmOptions.extraLarge.width / CmToInchModifier),
    height: Math.round(ParcelDimensionsCmOptions.extraLarge.height / CmToInchModifier),
  },
};

export const ParcelDimensionsOptionsByUnitOfMeasure: Record<
  UnitOfMeasure,
  Record<ParcelDimensionsOptionType, ParcelDimensionsOption>
> = {
  [UnitOfMeasure.Metric]: ParcelDimensionsCmOptions,
  [UnitOfMeasure.Imperial]: ParcelDimensionsInchOptions,
};

export class ParcelOption {
  parcelType: ParcelDimensionsOptionType;
  weight: number;
  description?: string;
}
